export default "__VITE_ASSET__5a6baaed__"